module.exports = __webpack_public_path__ + "static/img/per-img2.063a757.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/common/per-img2.png
// module id = /JJy
// module chunks = 1